import { render, staticRenderFns } from "./GFilesInFoldersList.vue?vue&type=template&id=4c75fbb3&"
import script from "./GFilesInFoldersList.vue?vue&type=script&lang=js&"
export * from "./GFilesInFoldersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports